import { WelcomeMessageButton } from './settings';

export enum ChatConversationMode {
  AUTO = 'AUTO',
  MANUAL = 'MANUAL',
}

export enum ChatMessageType {
  USER_QUESTION = 'USER_QUESTION',
  AI_RESPONSE = 'AI_RESPONSE',
  STAFF_RESPONSE = 'STAFF_RESPONSE',
  SYSTEM_MESSAGE = 'SYSTEM_MESSAGE',
  LOADING_MESSAGE = 'LOADING_MESSAGE',
}

export interface ChatConversationMessage {
  id: string;
  conversation_id: string;
  supplier_id: string;
  visitor_id: string;
  message_type: ChatMessageType;
  content: string;
  welcome_message_text?: string;
  button_options?: WelcomeMessageButton[];
  selected_button?: string;
  digital_map_id?: string;
  location?: { lat: number; lng: number };
  sender_id: string;
  topic?: string;
  could_not_answer?: boolean;
  show_itinerary_button?: boolean;
  feedback_rating?: FeedbackRating;
  created_date_time_utc: string;
}

export interface ChatConversation {
  id: string;
  supplier_id: string;
  visitor_id: string;
  mode: ChatConversationMode;
  escalation_reason?: string;
  messages: ChatConversationMessage[];
  created_date_time_utc: string;
  updated_date_time_utc: string;
}

export interface ChatConversationMessageParams {
  conversation_id: string;
  content: string;
  welcome_message_text?: string;
  button_options?: WelcomeMessageButton[];
  selected_button?: string;
  digital_map_id?: string;
  customer_id?: string;
  location?: { lat: number; lng: number };
}

export interface ChatConversationModeUpdateRequest {
  mode: ChatConversationMode;
  escalation_reason?: string;
}

export type FeedbackRating =
  | 'FEEDBACK_RATING_UNSPECIFIED'
  | 'FEEDBACK_RATING_UNRATED'
  | 'FEEDBACK_RATING_LIKED'
  | 'FEEDBACK_RATING_UNLIKED';

export interface ChatMessageRatingUpdateRequest {
  feedback_rating: FeedbackRating;
}
